export class Logout {
    public static readonly type = '[RootState] Logout';
}
